import styled from 'styled-components';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button, IconButton, IconName } from '@optimus-web/core';
import { ANIMATION_DURATION } from '@optimus-web/common';
import { COLOR_WHITE } from '../../../components/commander-ui/constants';

export const ScannerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
`;

export const CanvasWrapper = styled.div`
    position: relative;
    transform: translateY(-50%);
    transition: transform ${ANIMATION_DURATION.default}ms ease-in-out;
    ${(props) =>
        (props as $TSFixMe).isOpened &&
        `
        transform: translateY(0%);
    `}
    max-height: 70vh;
    overflow: hidden;
`;

export const MessageWrapper = styled.span`
    font-size: 36px;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

export const ButtonHolder = styled.div`
    padding: 0px 8px;
    display: flex;
`;

const ActionsWrapper = styled.div`
    flex: 1 1;
    display: flex;
    align-content: center;
    padding: 6px 0px;
`;

export const RightActionsWrapper = styled(ActionsWrapper)`
    justify-content: flex-end;
`;

export const LeftActionsWrapper = styled(ActionsWrapper)`
    justify-content: flex-start;
`;

export const SwitchButton = styled(Button)``;
SwitchButton.defaultProps = {
    children: <LocalizedText textKey={TextKey.ChangeCamera} />,
};

export const CancelButton = (props: $TSFixMe) => <Button variant="ghost" {...props} type="submit" />;
CancelButton.defaultProps = {
    children: <LocalizedText textKey={TextKey.GoBack} />,
};

export const ResetButton = (props: $TSFixMe) => <Button variant="ghost" {...props} type="submit" />;
ResetButton.defaultProps = {
    children: <LocalizedText textKey={TextKey.TryAgain} />,
};
export const MobileResetButton = styled(IconButton)`
    padding: 4px 8px;
    height: 36px;
    display: flex;
`;
MobileResetButton.defaultProps = {
    icon: IconName.Refresh,
    variant: 'ghost',
};

export const ScanButton = (props: $TSFixMe) => <Button variant="primary" {...props} type="submit" />;
ScanButton.defaultProps = {
    children: <LocalizedText textKey={TextKey.Scan} />,
};

export const SaveButton = (props: $TSFixMe) => <Button variant="primary" {...props} type="submit" />;
SaveButton.defaultProps = {
    children: <LocalizedText textKey={TextKey.Save} />,
};

export const VideoPlayer = styled.video`
    width: 100%;
    height: auto;
`;

export const Canvas = styled.canvas`
    width: 100%;
    height: auto;
    position: absolute;
    top: 0px;
    left: 0px;
    opacity: 0;
    ${(props) =>
        (props as $TSFixMe).isVisible &&
        `
        opacity: 1;
    `}
`;

export const EditorWrapper = styled.div`
    position: absolute;
    height: calc(100% - 48px);
    transition-property: opacity, bottom;
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-timing-function: ease-in-out;
    bottom: -100%;
    opacity: 0;
    width: 100%;
    background: ${COLOR_WHITE};
    ${(props) =>
        (props as $TSFixMe).isOpened &&
        `
        bottom: 0px;
        opacity: 1;
    `}
    display: flex;
    flex-direction: column;
`;

export const ColumnsWrapper = styled.div`
    display: flex;
    flex: 1 1;
    flex-direction: row;
    ${(props) =>
        (props as $TSFixMe).singleColumn &&
        `
        flex-direction: column;
    `}
    overflow: auto;
`;

export const Column = styled.div`
    width: 50%;
    ${(props) =>
        (props as $TSFixMe).singleColumn &&
        `
        width: 100%;
    `}
    padding: 16px;
`;
